module.exports = __webpack_public_path__ + "img/home-apart-mob.c7937325.jpg";